import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { DeploymentProvider } from "./deployment/DeploymentContext";
import { ThemeProvider } from "./theme/ThemeContext";
import App from "./App";
import "./styles/global.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <DeploymentProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
        </DeploymentProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
